import { Instagram, Mail, MapPin, MessageCircle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="py-12 bg-black border-t border-white/5"
      data-testid="footer"
    >
      <div className="section-container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="text-center md:text-left">
            <a 
              href="#" 
              className="inline-block"
            >
              <img 
                src="/locker-room-logo.png" 
                alt={t("alts.logo")}
                className="h-16 w-auto"
              />
            </a>
            <p className="text-zinc-600 font-body text-sm mt-2">
              {t("footer.tagline")}
            </p>
          </div>
          
          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="mailto:lockeroom.egypt@gmail.com"
              className="social-link"
              aria-label="Email"
              data-testid="footer-email"
            >
              <Mail className="w-5 h-5" />
            </a>
            <a
              href="https://instagram.com/locker_room_egypt"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
              data-testid="footer-instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/201037255878"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="WhatsApp"
              data-testid="footer-whatsapp"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
            <a
              href="#location"
              className="social-link"
              aria-label="Location"
              data-testid="footer-location"
            >
              <MapPin className="w-5 h-5" />
            </a>
          </div>
          
          {/* Copyright */}
          <div className="text-center md:text-right">
            <p className="text-zinc-600 font-body text-sm">
              © {currentYear} Locker Room. {t("footer.rights")}
            </p>
            <p className="text-zinc-700 font-body text-xs mt-1">
              Marina of Port Ghalib, Red Sea, Egypt
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
